module.exports = __webpack_public_path__ + "static/media/alert_partner_platinum_x1_new.033e468b.png";